import { Reducer } from 'redux';
import { KnownAction } from './newsActions';
import { ApiNewsState } from './newsModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<ApiNewsState> = (state: ApiNewsState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            thenews: [],
            internalnews: [],
            loading: false,
            loadinginternal: false
        };
    }

    switch (action.type) {
        case 'ADD_NEWS':
            return Object.assign({}, state, { thenews: action.data });
        case 'SET_LOADING_NEWS':
            return Object.assign({}, state, { loading: action.data });
        case 'ADD_NEWS_INTERNAL':
            return Object.assign({}, state, { internalnews: action.data });
        case 'SET_LOADING_NEWS_INTERNAL':
            return Object.assign({}, state, { loadinginternal: action.data });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/news/newsReducers.ts